import WithRender from "../../templates/layouts/layoutPersonalizationConfiguration.html";
import { mapGetters } from "vuex";

export default WithRender({
  computed: {
    ...mapGetters(["getCimpressNoQuantity"])
  }
});
